import { getOuterUrl } from '@wix/communities-blog-client-common';

export const getInternalLinkRoute = ({ topology, to, shouldNavigateToFeed }) => {
  const { baseUrl, isHomePage, sectionUrl: feedSectionUrl, postPageSectionUrl } = topology;
  const path = to === '/' ? '' : to;
  const sectionUrl = shouldNavigateToFeed ? (path === '' && isHomePage ? baseUrl : feedSectionUrl) : postPageSectionUrl;

  return getOuterUrl(path, sectionUrl);
};
